// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { RecordingPlayer } from './RecordingPlayer';

export default RecordingPlayer;
